import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-define-params',
  templateUrl: './define-params.component.html',
  styleUrls: ['./define-params.component.css']
})
export class DefineParamsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
